import styled from "styled-components";
import { slugify } from "healthex-common/utils";
import { FlexColumnDiv } from "./common.styles";
import Button from "@mui/material/Button";
import { fontSizes } from "healthex-common/sizes";
import { colors } from "healthex-common/colors";
import { fontWeights } from "healthex-common/weights";
import { ContentContainer } from "./HXMobilePage.styles";
import { multilineEllipsis } from "./base.styles";
export const PrescreenContentContainer = styled(ContentContainer) `
    gap: 24px;
`;
export const EnrolledContentContainer = styled(ContentContainer) `
    gap: 40px;
`;
export const OptionsContainer = styled(FlexColumnDiv) `
    padding: 0;
    align-items: flex-start;
    align-self: stretch;
    gap: 16px;
`;
export const OptionsButton = styled(Button).attrs((props) => ({
    "data-heap-id": props.analyticsId ? slugify(props.analyticsId) : undefined,
})) `
    min-height: 80px;
    padding: 16px;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    border: 1px solid ${colors.black_12};
    background-color: ${(props) => `${props.isSelected ? colors.navy_12 : colors.white_main}`} !important;
    align-self: stretch;

    color: ${colors.black_main};
    font-size: ${fontSizes.MEDIUM};
    font-weight: ${fontWeights.SEMI_BOLD};
    text-align: center;
    line-height: normal;
    letter-spacing: 0.15px;

    display: inline-block !important;
    ${multilineEllipsis(2)}
`;
export const SecondaryOptionsButton = styled(OptionsButton) `
    height: 40px;
    padding: 0 24px;
    border: 0px solid ${colors.black_12};
    background-color: ${(props) => `${props.isSelected ? colors.navy_12 : "transparent"}`} !important;
    align-self: center;
    text-decoration-line: underline;
    text-underline-offset: 3px;
    font-size: ${fontSizes.STANDARD};
`;
